import React from 'react';
import AiPersona from '../../components/AiPersona/AiPersona';
import Canonical from '../../utils/Canonical';

const AiPersonaPage = () => {
  return (
    <>
      <Canonical path='/blog-guideline' title='blog guideline' />
      <AiPersona />
    </>
  );
};

export default AiPersonaPage;
